import queries from '~layers/app/assets/css/tokens/media-queries.module.js'

export function useApp() {
  const bps = useState('bps', () => {
    const bps: any = {
      mobile: 0,
    }

    Object.keys(queries).filter(query => query.includes('-plus')).forEach((breakpoint) => {
      let value = queries[breakpoint].replace('(width >= ', '').replace(')', '')

      if (value.includes('em')) {
        value = 16 * parseFloat(value)
      }
      else if (value.includes('px')) {
        value = parseFloat(value)
      }

      bps[breakpoint.replace('-plus', '')] = value
    })

    return bps
  })

  const vuBreakpoints = useBreakpoints(bps.value)
  const breakpoints = Object.keys(bps.value)
  const breakpoint = ref()

  const debugmode = useState('debugmode', () => false)
  const scrollingDisabled = useState('scrollingDisabled', () => false)
  const initiatedThirdParty = useState('initiatedThirdParty', () => false)

  let breadcrumbs = reactive({})

  const setBreadcrumbs = (newBreadcrumbs: any) => {
    breadcrumbs = newBreadcrumbs
  }

  const disableScrolling = (disabled: boolean) => {
    scrollingDisabled.value = disabled
  }

  const getDebugmode = () => {
    debugmode.value = sessionStorage.getItem('debugmode') === 'true'
  }

  const setDebugmode = (newDebugmode: boolean) => {
    sessionStorage.setItem('debugmode', newDebugmode.toString())
    debugmode.value = newDebugmode
  }

  const setInitiatedThirdParty = (newInitiatedThirdParty: boolean) => {
    initiatedThirdParty.value = newInitiatedThirdParty
  }

  onMounted(() => {
    watchEffect(() => {
      breakpoint.value = vuBreakpoints?.current()?.value?.pop()
    })
  })

  return {
    debugmode,
    bps,
    breakpoint,
    breakpoints,
    vuBreakpoints,
    queries,
    breadcrumbs,
    scrollingDisabled,
    initiatedThirdParty,
    disableScrolling,
    getDebugmode,
    setBreadcrumbs,
    setDebugmode,
    setInitiatedThirdParty,
  }
}
